export default __webpack_public_path__ + "static/media/treat-yourself-1440w.b1a14f3b.webp";